import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { DtoCoVendedor } from '../dominio/DtoCoVendedor';
import { CoVendedor } from '../dominio/CoVendedor';
import { UHttpsClient } from 'src/app/seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoVendedorServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/covendedor/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerPorId(): Promise<CoVendedor> {
        return this.http.get(`${this.url}obtenerPorId`,{ headers: this.headers})
            .toPromise()
            .then(response => {
                return response as CoVendedor;
            })
            .catch(error => null);
    }

    public listarActivosDto(): Promise<DtoCoVendedor[]> {
        return this.http.get(`${this.url}listarActivosDto`,{ headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoCoVendedor[];
            })
            .catch(error => []);
    }

    buscarIna(bean: DtoCoVendedor): Promise<any> {
        return this.http.post(`${this.url}buscarInactivo`, bean, {headers: this.headers})
            .toPromise()
            .then(response => response as number)
            .catch(error => null);
    }


}

